import { useContext } from "react";
import { CreateQuoteContext } from "../../CreateQuote";
import { useNavigate } from "react-router-dom";
import { clearPISessionStorage } from "../../../../helpers/shared/sessionStorage";
import SummaryDetail from "../../components/SummaryDetail";

const clearFormSession = () => clearPISessionStorage("au/group_travel/form/");

const Summary: React.FC = () => {
  const { state } = useContext(CreateQuoteContext);
  const navigate = useNavigate();
  const goToListing = () => {
    clearFormSession();

    navigate("/au/group_travel/retrieve-list");
  };
  const goToBind = () => {
    clearFormSession();
    navigate("/au/group_travel/bind/proposer-details", { state });
  };
  return <SummaryDetail state={state} goToBind={goToBind} goToListing={goToListing} />;
};

export default Summary;
